module.exports = __webpack_public_path__ + "static/hero-4c48ea96a51e0b5bd69d64c6f6a4d866.jpg";